import { render } from "./ContactMainSection.vue?vue&type=template&id=073b8e52"
import script from "./ContactMainSection.vue?vue&type=script&lang=js"
export * from "./ContactMainSection.vue?vue&type=script&lang=js"

import "./ContactMainSection.vue?vue&type=style&index=0&id=073b8e52&lang=css"

import exportComponent from "D:\\eestec sajt trenutni\\eestec.etf.rs\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__